import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const P_INTERNE_SCHEMA_LITERAL = {
    title: 'Schéma Interne',
    description: 'Décrit les documents internes',
    version: 1,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        CBINDICE: { type: 'number' },
        D_INTITULE: { type: 'string' },
        D_MVTSTOCK: { type: 'number' }
    },
    required: [ 'CBMARQ' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(P_INTERNE_SCHEMA_LITERAL);
export type RxPInterneDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const P_INTERNE_SCHEMA: RxJsonSchema<RxPInterneDocumentType> = P_INTERNE_SCHEMA_LITERAL;
